<template>
    <!--弹窗-->
    <el-dialog
        width="90%"
        title=""
        top="3vh"
        :visible.sync="visible"
        :before-close="handleClose"
    >
        <div class="dialogCon">
            <el-button @click="exportFunc" type="success" size="mini" style="float:right;">导 出</el-button>
            <div class="subTitle">基础信息</div>
            <div class="top1">
                <div class="top1Left">
                        <img style="width:90px;height:90px;" :src="formData.img_url" v-if="formData.img_url"/>
                </div>
                <div class="top1Right">
                    <div class="itemInfo">
                        <div class="itemTitle">ID:</div>
                        <div class="itemContent">{{ formData.id }}</div>
                    </div>
                    <div class="itemInfo">
                        <div class="itemTitle">ASIN:</div>
                        <div class="itemContent">
                            <icon-svg :icon-class="formData.state.toUpperCase()"
                                      style="font-size: 24px;margin-right:5px;" v-if="formData.state"></icon-svg>
                            {{ formData.asin }}
                        </div>
                    </div>
                    <div class="itemInfo">
                        <div class="itemTitle">类目:</div>
                        <div class="itemContent" @click="showInfo('类目', formData.category)">{{
                                formData.category
                            }}
                        </div>
                    </div>

                    <div class="itemInfo">
                        <div class="itemTitle">专利:</div>
                        <el-button type="success" :disabled="!formData.patent_file"
                                   @click="downFile(formData.patent_file)" size="mini">下载</el-button>
                        <div class="itemContent">{{ formData.patent_value }}</div>
                    </div>

                    <div class="itemInfo">
                        <div class="itemTitle">父ASIN:</div>
                        <div class="itemContent">{{ formData.parent_asin }}</div>
                    </div>

                    <div class="itemInfo">
                        <div class="itemTitle">品牌:</div>
                        <div class="itemContent" @click="showInfo('品牌', formData.brand)">{{ formData.brand }}
                        </div>
                    </div>

                    <div class="itemInfo">
                        <div class="itemTitle">评分:</div>
                        <div class="itemContent">{{ formData.rating }}</div>
                    </div>

                    <div class="itemInfo">
                        <div class="itemTitle">评论数:</div>
                        <div class="itemContent">{{ formData.rating_count }}</div>
                    </div>

                </div>
            </div>

        </div>
        <div class="lineDom"></div>

        <div class="dialogCon">
            <div class="subTitle">调节参数</div>
            <div class="top2">
                <div class="line1">
                    <div class="itemInfo">
                        <div class="itemTitle">1688产品价格 :</div>

                        <el-input-number
                            v-model="formData.ali_factory_price"
                            style="width: 150px;"
                            :min="0.00"
                            :step="0.01"
                            size="mini"
                            placeholder="请输入产品价格"
                        >
                        </el-input-number>

                        <p class="fixedBox" v-if="!['null', null, ''].includes(formData.purchase_average_price)">
                             采购均价: {{formData.purchase_average_price}} </br> 其他均价: {{formData.other_average_price}}</p>
                    </div>

                    <div class="itemInfo">
                        <div class="itemTitle">退货率:</div>
                        <el-input v-model="formData.refund_rate" style="width: 150px;margin-right:20px;" size="mini"
                                  placeholder="请输入退货率">
                            <template slot="append">%</template>
                        </el-input>
                    </div>

                    <div class="itemInfo">
                        <div class="itemTitle">销售价格:</div>
                        <el-input-number
                            v-model="formData.selling_price"
                            style="width: 180px;"
                            :min="0.00"
                            :step="0.01"
                            size="mini"
                            placeholder="请输入销售价格"
                        >
                        </el-input-number>

                    </div>

                    <div class="itemInfo">
                        <div class="itemTitle">标品类型:</div>
                        <el-select v-model="formData.standard_product_type" placeholder="标品类型" size="mini">
                            <el-option label="全部" value=""></el-option>
                            <el-option label="未录入" :value="-1"></el-option>
                            <el-option :label="item.name" :value="item.value"
                                       v-for="item in standardProductTypeArr"></el-option>
                        </el-select>
                    </div>

                    <!--                    <div class="itemInfo">-->
                    <!--                        <div class="itemTitle">指定运输模式:</div>-->

                    <!--                        <el-select v-model="formData.set_deliver_mode" placeholder="请选择" size="mini" filterable>-->
                    <!--                            <el-option :label="item.label == '全部' ? '默认' : item.label" :value="item.value"-->
                    <!--                                       v-for="item in $common.deliverModeArr"></el-option>-->
                    <!--                        </el-select>-->
                    <!--                    </div>-->
                </div>
                <div class="line2">
                    <div class="itemInfo">
                        <div class="itemTitle">规格-长(cm):</div>
                        <el-input style="width: 150px;" clearable v-model="formData.long"
                                  placeholder="请输入规格-长(cm)" size="mini"></el-input>
                    </div>
                    <div class="itemInfo">
                        <div class="itemTitle">规格-宽(cm):</div>
                        <el-input style="width: 150px;" clearable v-model="formData.wide"
                                  placeholder="请输入规格-宽(cm)" size="mini"></el-input>
                    </div>
                    <div class="itemInfo">
                        <div class="itemTitle">规格-高(cm):</div>
                        <el-input style="width: 150px;" clearable v-model="formData.height"
                                  placeholder="请输入规格-高(cm)" size="mini"></el-input>
                    </div>
                    <div class="itemInfo">
                        <div class="itemTitle">规格-重(g):</div>
                        <el-input style="width: 150px;" clearable v-model="formData.weight"
                                  placeholder="请输入规格-重(g)" size="mini"></el-input>
                    </div>
                </div>
                <div class="line2">
                    <div class="itemInfo">
                        <div class="itemTitle">是否季节性:</div>
                        <el-select v-model="formData.is_seasonality" size="mini">
                            <el-option label="是" :value="1"></el-option>
                            <el-option label="否" :value="0"></el-option>
                        </el-select>
                    </div>
                    <div class="itemInfo">
                        <div class="itemTitle">季节:</div>
                        <el-select v-model="formData.season" placeholder="请选择" size="mini" filterable clearable>
                            <el-option :label="item.label" :value="item.value"
                                       v-for="item in $common.seasonArrNoDefault"></el-option>
                        </el-select>
                    </div>
                </div>
            </div>
        </div>

        <div class="lineDom"></div>
        <div class="dialogCon">
            <div class="subTitle">成本结算</div>
            <div class="top4">
                <div class="line1">
                    <div class="itemInfo">
                        <div class="itemTitle">运费:</div>
                        <div class="itemContent">{{ formData.freight }}</div>
                    </div>
                    <div class="itemInfo">
                        <div class="itemTitle">真实运费:</div>
                        <div class="itemContent" :class="{greenClass: formData.real_freight}">{{ formData.real_freight }}</div>
                    </div>
                    <div class="itemInfo">
                        <div class="itemTitle">平台佣金:</div>
                        <div class="itemContent">{{ formData.platform_commission }}</div>
                    </div>
                    <div class="itemInfo">
                        <div class="itemTitle">配送费:</div>
                        <div class="itemContent">{{ formData.delivery_charge }}</div>
                    </div>
                </div>
                <div class="line2">
                    <div class="itemInfo">
                        <div class="itemTitle">退货费用:</div>
                        <div class="itemContent">{{ formData.refund_charge }}</div>
                    </div>
                    <div class="itemInfo">
                        <div class="itemTitle">仓储费:</div>
                        <div class="itemContent">{{ formData.storage_charge }}</div>
                    </div>
                    <div class="itemInfo">
                        <div class="itemTitle">利润:</div>
                        <div class="itemContent">{{
                                formData.profit
                            }}
                        </div>
                    </div>
                    <div class="itemInfo">
                        <div class="itemTitle">利润率:</div>
                        <div class="itemContent">{{formData['profit_rate'] ? accMul(formData['profit_rate'], 100) + '%' : '-' }}</div>
                    </div>

                </div>
                <div class="line2">
                    <div class="itemInfo">
                        <div class="itemTitle">投资回报率:</div>
                        <div class="itemContent">{{
                                formData['investment_return_rate'] ?
                                    (accMul(formData['investment_return_rate'], 100) + '%') : '-'
                            }}
                        </div>
                    </div>
                    <div class="itemInfo">
                        <div class="itemTitle">0利润销售价格:</div>
                        <div class="itemContent">{{ formData.seller_price_no_profit }}</div>
                    </div>
                </div>
            </div>

        </div>

        <span slot="footer" class="dialog-footer">
            <el-button @click="handleClose" type="primary" size="mini">关 闭</el-button>
            <el-button @click="updateFunc" type="success" size="mini" v-show="modalType===0">更 新</el-button>
        </span>
        <child-info-modal :visible="childInfoVisible" :info="previewInfo"
                          @close-callback="closeCllback"></child-info-modal>
    </el-dialog>
</template>
<script>
import childInfoModal from '@/views/warehouse/childInfoModal.vue'
import * as api from '@/api/advAnalys/advAnalys.js'
import {downloadFileUrl} from '@/utils/method'
import {low_price_mall_commonExport} from '@/api/advAnalys/advAnalys.js'

export default {
    components: {childInfoModal},
    data() {
        return {
            selectionPrincipleList: [],
            standardProductTypeArr: [
                {name: '标品-大众', value: '标品-大众'},
                {name: '标品-小众', value: '标品-小众'},
                {name: '非标-大众', value: '非标-大众'},
                {name: '非标-小众', value: '非标-小众'},
            ],
            visible: false,
            formData: {},
            childInfoVisible: false,
            previewInfo: {},
            itemData: {},
            modalType: 0
        }
    },
    methods: {
        // 获取成本分析字符串
        getCostAnalysisTxt(num) {
            let txt = '分析中'
            switch (num) {
                case 0:
                    txt = '待分析'
                    break
                case -1:
                    txt = '分析失败'
                    break
                case 2:
                    txt = '分析完成'
                    break
                default:
                    txt = '分析中'
            }
            return txt
        },
        exportFunc() {
            api.low_price_mall_commonExport({id: this.itemData.analysis_id}).then(res => {
                if (res.code === 0) {
                    this.downFile(res.data)
                } else {
                    this.$message({type: 'error', message: res.message})
                }
            }).finally(() => {
                this.loading = false
            })
        },
        downFile(path) {
            if (!path) {
                return this.$message({
                    type: 'error',
                    message: '无法下载！'
                })
            }
            downloadFileUrl(path)
        },
        jumpUrl(url) {
            window.open(url, '_blank')
        },
        closeCllback() {
            this.childInfoVisible = false
            this.previewInfo = {}
        },
        showInfo(title, info) {
            console.log('==')
            this.previewInfo = {title, info}
            this.childInfoVisible = true
        },
        showModal(data, itemData, type = 0) {
            console.log('--', data, itemData)
            this.formData = data
            this.itemData = itemData
            this.modalType = type
            this.visible = true
        },
        // 关闭弹窗
        handleClose() {
            this.visible = false
            // this.$emit('close-callback', this.closeFlag)
        },
        updateFunc() {
            if (this.formData.is_seasonality && ['', undefined, null].includes(this.formData.season)) {
                this.$message({type: 'error', message: '是季节性，需选择季节'})
                return
            }
            if (!this.formData.is_seasonality && !['', undefined, null].includes(this.formData.season)) {
                this.$message({type: 'error', message: '不是季节性，需清空选择的季节'})
                return
            }
            if (!this.formData.is_seasonality) {
                this.formData.season = ''
            }

            const tempData = JSON.parse(JSON.stringify(this.formData))
            tempData.refund_rate = tempData.refund_rate / 100
            api.low_price_mall_operating_update_cost_analysis_details(tempData).then(res => {
                if (res.code === 0) {
                    let obj = Object.assign(this.formData, res.data)
                    obj.refund_rate = this.accMul(obj.refund_rate, 100)
                    this.$set(this, 'formData', obj)
                    this.$message({type: 'success', message: '更新成功'})
                    this.$emit('close-callback', true)
                } else {
                    this.$message({type: 'error', message: res.message})
                }
            }).finally(() => {
                this.loading = false
            })
        },
        /**
         * 数字相乘
         * @param {*} arg1
         * @param {*} arg2
         * @returns
         */
        accMul(arg1, arg2) {
            let m = 0
            m = this.accAdd(m, this.getDecimalLength(arg1))
            m = this.accAdd(m, this.getDecimalLength(arg2))
            return this.getNum(arg1) * this.getNum(arg2) / Math.pow(10, m)
        },
        getNum(arg = '') {
            return Number(arg.toString().replace('.', ''))
        },
        /**
         * 数字相加
         * @param {*} arg1
         * @param {*} arg2
         * @returns
         */
        accAdd(arg1, arg2) {
            return this.changeNum(arg1, arg2)
        },
        changeNum(arg1 = '', arg2 = '', isAdd = true) {
            const changeInteger = (arg, r, maxR) => {
                if (r != maxR) {
                    let addZero = ''
                    for (let i = 0; i < maxR - r; i++) {
                        addZero += '0'
                    }
                    arg = Number(arg.toString().replace('.', '') + addZero)
                } else {
                    arg = this.getNum(arg)
                }
                return arg
            }

            let r1, r2, maxR, m
            r1 = this.getDecimalLength(arg1)
            r2 = this.getDecimalLength(arg2)
            maxR = Math.max(r1, r2)
            arg1 = changeInteger(arg1, r1, maxR)
            arg2 = changeInteger(arg2, r2, maxR)
            m = Math.pow(10, maxR)
            if (isAdd) {
                return (arg1 + arg2) / m
            } else {
                return (arg1 - arg2) / m
            }
        },
        getDecimalLength(arg = '') {
            try {
                return arg.toString().split('.')[1].length
            } catch (e) {
                return 0
            }
        },

        spanMethod({row, column, rowIndex, columnIndex}) {

            const columns = [13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28]
            if (rowIndex % 3 == 0) {
                if (columns.includes(columnIndex)) {
                    return {
                        rowspan: 1,
                        colspan: 1
                    }
                }
                return {
                    rowspan: 3,
                    colspan: 1
                }
            } else {
                if (columns.includes(columnIndex)) {
                    return {
                        rowspan: 1,
                        colspan: 1
                    }
                }
                return {
                    rowspan: 0,
                    colspan: 0
                }
            }
        },
    }
}
</script>
<style type="text/scss" lang="scss" scoped>

.top1 {
    width: 100%;
    display: flex;
    justify-content: space-between;

    .top1Right {
        display: flex;
        flex-wrap: wrap;
        width: 1200px;

        .itemInfo {
            width: 360px;
            display: flex;
            height: 28px;
            line-height: 28px;

            .itemTitle {
                font-size: 14px;
                color: #606266;
                padding: 0 10px 0 0;
                font-weight: 900;
            }

            .itemContent {
                width: 230px;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
            }
        }
    }
}

.greenClass {
    color: #19be6b;
    font-weight: bold;
}

.subTitle {
    height: 30px;
    font-size: 18px;
    font-weight: 800;
    margin: 5px 0 0;
}

.subTitle2 {
    height: 20px;
    font-size: 16px;
    font-weight: 800;
}

.itemInfo {
    display: flex;

    .itemTitle {
        font-size: 14px;
        color: #606266;
        padding: 0 12px 0 0;
        font-weight: 800;
    }

    .itemContent {
        width: 200px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }
}

.itemInfo:not(:first-child) {
    margin-top: 5px;
}

.lineDom {
    width: auto;
    height: 1px;
    background: black;
    margin: 10px 0;
}

.wrapBox {
    width: 600px;
    margin-top: 10px;

    .bottomBox {
        margin-top: 17px;
        display: flex;
        justify-content: center;
    }
}

.download {
    display: flex;
    justify-content: center;
}

.top {
    margin: 0px auto 20px;
    width: 60%;
    display: flex;
    justify-content: space-between;
}

.top2 {
    .line1, .line2 {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: left;

        .itemInfo {
            width: 25%;
            position: relative;
        }

        .fixedBox {
            position: absolute;
            left: 250px;
            bottom: 7px;
            color: green;
            /* width: 210px; */
            white-space: nowrap;
            border-radius: 5px;
            background: #dadada;
            font-size: 11.5px;
            border: 1px solid black;
            padding: 7px 15px;
            line-height: 20px;
        }

        .itemContent {
            width: 100px;
        }

        .itemTit {
            height: 28px;
            line-height: 28px;
            font-size: 14px;
            color: #606266;
            padding: 0 12px 0 0;
            font-weight: 900;
        }
    }

    .itemInfo {
        display: flex;
        justify-content: start;
        height: 28px;
        line-height: 28px;

        .itemTitle {
            font-size: 14px;
            color: #606266;
            padding: 0 12px 0 0;
            font-weight: 900;
        }

        .itemContent {
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
        }
    }
}


.top4 {
    .line1, .line2, .line4, .line3 {
        display: flex;
        justify-content: start;
    }

    .itemInfo {
        width: 25%;
        display: flex;
        height: 28px;
        line-height: 28px;
        margin-bottom: 10px;

        .itemTitle {
            font-size: 14px;
            color: #606266;
            padding: 0 12px 0 0;
            font-weight: 900;
        }

        .itemContent {
            max-width: 230px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
        }
    }

    .line4 {
        .line4Left, .line4Right {
            width: 50%;
        }

        .itemInfo {
            width: 100%;
        }
    }

}


</style>

